<div class="home-footer-container flex flex-row items-center justify-between mx-9">
	<div class="contact-container flex flex-col text-sm md:text-base">
		<p class="hidden md:block">
			Contacto: <span>{{ 'info@obd.com.ar' }}</span>
		</p>
		<p class="">
			Asistencia técnica: <span>{{ 'help@obd.com.ar' }}</span>
		</p>
		<p class="hidden md:block">
			Web: <span>{{ 'obd.com.ar' }}</span>
		</p>
	</div>
	<div class="logo-container flex flex-row items-center text-nowrap">
		<p class="text-sm md:text-base">Powered By</p>
		<img src="./../../../../../assets/obd-logo.svg" alt="OBD logo" />
	</div>
</div>
